// Every page component the router mounts, each behind lazyWithRetry so that a chunk gone
// stale after a deploy retries instead of white-screening. Split out of routes.ts, which the
// repository's 300 LOC limit no longer fits: these declarations and the route table are two
// separate responsibilities, and only the table is read when following a path to a page.

import lazyWithRetry from "utils/lazyWithRetry";

// Auth Containers
export const Login = lazyWithRetry(() => import("containers/Auth/Login"), "Login");
export const AcceptInvitation = lazyWithRetry(
	() => import("containers/Auth/AcceptInvitation"),
	"AcceptInvitation",
);
export const ForgotPassword = lazyWithRetry(
	() => import("containers/Auth/ForgotPassword"),
	"ForgotPassword",
);
export const ResetPassword = lazyWithRetry(
	() => import("containers/Auth/ResetPassword"),
	"ResetPassword",
);
export const Register = lazyWithRetry(() => import("containers/Auth/Register"), "Register");
export const VerifyEmail = lazyWithRetry(
	() => import("containers/Auth/VerifyEmail"),
	"VerifyEmail",
);
export const Confirm2FA = lazyWithRetry(() => import("containers/Auth/Confirm2FA"), "Confirm2FA");
export const BlockedRegister = lazyWithRetry(
	() => import("containers/Auth/BlockedRegister"),
	"BlockedRegister",
);

// Other Containers
export const Profile = lazyWithRetry(() => import("containers/Profile"), "Profile");
export const NotFound = lazyWithRetry(() => import("containers/NotFound"), "NotFound");

// MapX Pages
export const CandidateDetails = lazyWithRetry(
	() => import("mapx-pages/CandidateDetails"),
	"CandidateDetails",
);
export const CompanyDetails = lazyWithRetry(
	() => import("mapx-pages/CompanyDetails"),
	"CompanyDetails",
);
export const Error = lazyWithRetry(() => import("mapx-pages/Error"), "Error");
export const ExtendedSearch = lazyWithRetry(
	() => import("mapx-pages/ExtendedSearch"),
	"ExtendedSearch",
);
export const ExtendedSearchAiRuns = lazyWithRetry(
	() => import("mapx-pages/ExtendedSearch/AiRuns"),
	"ExtendedSearchAiRuns",
);
export const FlaggedCandidatesPage = lazyWithRetry(
	() => import("mapx-pages/FlaggedCandidates"),
	"FlaggedCandidatesPage",
);
export const Home = lazyWithRetry(() => import("mapx-pages/Home"), "Home");
export const LearnToRank = lazyWithRetry(() => import("mapx-pages/LearnToRank"), "LearnToRank");
export const MarketMap = lazyWithRetry(() => import("mapx-pages/MarketMap"), "MarketMap");
export const Onboarding = lazyWithRetry(() => import("mapx-pages/Onboarding"), "Onboarding");
export const Organisation = lazyWithRetry(() => import("mapx-pages/Organisation"), "Organisation");
export const Organizations = lazyWithRetry(
	() => import("mapx-pages/Organizations"),
	"Organizations",
);
export const CustomerUsagePage = lazyWithRetry(
	() => import("mapx-pages/OrganisationUsage/CustomerUsagePage"),
	"CustomerUsagePage",
);
export const AdminUsagePage = lazyWithRetry(
	() => import("mapx-pages/OrganisationUsage/AdminUsagePage"),
	"AdminUsagePage",
);
export const ProjectEntry = lazyWithRetry(() => import("mapx-pages/Project"), "ProjectEntry");
export const ProjectsV2 = lazyWithRetry(() => import("mapx-pages/Projects"), "ProjectsV2");

// Polaris
export const PolarisEntry = lazyWithRetry(() => import("mapx-pages/Polaris"), "PolarisEntry");
export const PolarisSearches = lazyWithRetry(
	() => import("mapx-pages/Polaris/PolarisSearches"),
	"PolarisSearches",
);
export const PolarisAnalytics = lazyWithRetry(
	() => import("mapx-pages/PolarisAnalytics"),
	"PolarisAnalytics",
);
export const PolarisStrategy = lazyWithRetry(
	() => import("mapx-pages/Polaris/PolarisStrategy"),
	"PolarisStrategy",
);

// Search & Reports
export const CandidateSearch = lazyWithRetry(
	() => import("mapx-pages/CandidateSearch"),
	"CandidateSearch",
);
export const CompanySearch = lazyWithRetry(
	() => import("mapx-pages/CompanySearch"),
	"CompanySearch",
);
export const MarketReports = lazyWithRetry(
	() => import("mapx-pages/MarketReports"),
	"MarketReports",
);
export const MarketReportDetails = lazyWithRetry(
	() => import("mapx-pages/MarketReportDetails"),
	"MarketReportDetails",
);
export const MarketReportCreate = lazyWithRetry(
	() => import("mapx-pages/MarketReportCreate"),
	"MarketReportCreate",
);
